import { gql } from '@apollo/client';
import { LocaleCode, LOCALE_BY_CODE } from '../../../../../utils/Locale';

export const GET_RESOURCE_LIBRARY_ARTICLE_ITEM_QUERY = gql`
    query getResourceLibraryArticleItem($defaultLanguage: String!, $id: Int, $fullpath: String) {
        getResourceLibraryArticleItem(
            defaultLanguage: $defaultLanguage
            fullpath: $fullpath
            id: $id
        ) {
            id
            key
            name
            description
            sections {
                ... on fieldcollection_ArticleSection {
                    level
                    title
                    content
                }
                ... on fieldcollection_PlainTextArticleSection {
                    level
                    title
                    content
                }
            }
            coverImage {
                fullpath
            }
            brand {
                ... on object_Brand {
                    id
                }
            }
            productGroup {
                ... on object_ProductGroup {
                    id
                }
            }
            productApplication {
                ... on object_ProductApplicationSegment {
                    id
                }
                ... on object_ProductApplication {
                    id
                }
            }
            resourceType {
                ... on object_ResourceType {
                    id
                }
                ... on object_ResourceTypeGroup {
                    id
                }
            }
            navigationNode {
                ... on object_NavigationNode {
                    id
                }
            }
            navigationScope {
                ... on object_NavigationNode {
                    id
                }
            }
            exclusiveNavigationScope {
                ... on object_NavigationNode {
                    id
                }
            }
            publicationDate
            lastModificationDate
            thumbnailUrl: thumbnail
        }
    }
`;

export function getResourceLibraryArticleItemQueryVariables(
    localeCode: LocaleCode,
    id?: number,
    fullpath?: string
) {
    return {
        defaultLanguage: LOCALE_BY_CODE[localeCode].pimcoreCode,
        id: id ?? null,
        fullpath: fullpath ?? null,
    };
}
